(() => {
    window.addEventListener("DOMContentLoaded", () => {
        if (!document.querySelector('.mod-productconfiguratorslideout')) {
            return;
        }

        const panelToggler = document.querySelector('.mod-productconfiguratorslideout__button')
        const panelCloser = document.querySelector('.mod-productconfiguratorslideout__paneltoggler')
        const panel = document.querySelector('.mod-productconfiguratorslideout__panel')
        const currentConfig = JSON.parse(window.localStorage.getItem('productconfigurator'))

        panelToggler.addEventListener('click', () => {
            panel.classList.add('active')
        })

        panelCloser.addEventListener('click', () => {
            panel.classList.remove('active')
        })

        for (let attribute of ["parcels", "corebusiness", "region", "industry"]) {
            const attributeBox = document.querySelector('.mod-productconfiguratorslideout__attribute[data-attribute=' + attribute + ']')

            if (attribute === 'parcels') {
                attributeBox.querySelector('.mod-productconfiguratorslideout__editbutton').classList.remove('d-none')
                attributeBox.classList.remove('mod-productconfiguratorslideout__attribute--novalue')
            }

            if (!currentConfig || !currentConfig.hasOwnProperty(attribute)) {
                continue
            }

            const attributeConfig = currentConfig[attribute]

            if (!attributeConfig.label) {
                continue
            }

            attributeBox.classList.remove('mod-productconfiguratorslideout__attribute--novalue')
            attributeBox.querySelector('.mod-productconfiguratorslideout__currentvalue').innerText = attributeConfig.label
            attributeBox.querySelector('.mod-productconfiguratorslideout__editbutton').classList.remove('d-none')

            panel.querySelector('.mod-productconfiguratorslideout__intro--noconfig').classList.add('d-none')
            panel.querySelector('.mod-productconfiguratorslideout__intro--hasconfig').classList.remove('d-none')
            panelToggler.querySelector('.mod-productconfiguratorslideout__buttonlabel--noconfig').classList.add('d-none')
            panelToggler.querySelector('.mod-productconfiguratorslideout__buttonlabel--hasconfig').classList.remove('d-none')

            if (attribute === 'parcels') {
                continue
            }

            attributeBox.querySelector('.mod-productconfiguratorslideout__icon').setAttribute('src', '/media/mod_productconfigurator/img/icon/icon_' + attributeConfig.value + '.svg')
        }
    })
}) ()
